/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Check_In_Days_CompletedInputs */

const en_check_in_days_completed = /** @type {(inputs: Check_In_Days_CompletedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} of 13 days completed`)
};

const es_check_in_days_completed = /** @type {(inputs: Check_In_Days_CompletedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} de 13 dias completados`)
};

/**
* | output |
* | --- |
* | "{days} of 13 days completed" |
*
* @param {Check_In_Days_CompletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_days_completed = /** @type {((inputs: Check_In_Days_CompletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Days_CompletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_days_completed(inputs)
	return es_check_in_days_completed(inputs)
});